import { ReactElement, useEffect } from 'react';
import { Column, Grid, Row, Button, ButtonSet } from 'carbon-components-react';

import { FormattedMessage, useIntl } from 'react-intl';
import { scrollTo } from 'src/common/utils/smoothScroll';
import { segmentTracking } from '../lib/tracker';
import messages from '../locales/messages';
import './InstanaROI.scss';
import ThanksDetails from './ThanksDetails';
import { BVAResultsProps, PDFGenerate } from './PDFGenerate';

export interface ThanksProps {
  disruptions: number;
  preventions: number;
  speedGain: number;
  avgTime: string;
  itOpsEmployees: number;
  developers: number;
  developerEffiencyGains: string;
  itOpsEffiencyGains: string;
  openSourceGains: string;
  totalEffiencyGains: string;
  openSourceTechnoList: string;
  resultsImage?: string;
  summaryImage?: string;
  isPdf: boolean;
  pdfObject?: JSX.Element;
  pdfExport: boolean;
}

const Thanks = ({
  disruptions,
  preventions,
  speedGain,
  avgTime,
  itOpsEmployees,
  developers,
  developerEffiencyGains,
  itOpsEffiencyGains,
  openSourceGains,
  totalEffiencyGains,
  openSourceTechnoList,
  resultsImage,
  summaryImage,
  isPdf,
  pdfExport,
}: ThanksProps): ReactElement => {
  const intl = useIntl();
  const props: BVAResultsProps = {
    imgResults: resultsImage ? resultsImage : '',
    imgSummary: summaryImage ? summaryImage : '',
    pdfPara1: intl.formatMessage(messages.pdfPara1),
    pdfPara2: intl.formatMessage(messages.pdfPara2),
    pdfPara3: intl.formatMessage(messages.pdfPara3),
    pdfPara4: intl.formatMessage(messages.pdfPara4),
    pdfPara5: intl.formatMessage(messages.pdfPara5),
    pdfPara6: intl.formatMessage(messages.pdfPara6),
    pdfPara7: intl.formatMessage(messages.pdfPara7),
    heading: intl.formatMessage(messages.page_heading_3),
  };

  const pdfObject = PDFGenerate(props);
  useEffect(() => {
    scrollTo('ThankYou');
  }, []);

  return (
    <Grid id="ThankYou">
      <Row>
        <Column sm={4} md={8} lg={12}>
          <div className="bx--row padding-row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-16">
              <div className="thanks__pad1 page_heading">
                <FormattedMessage {...messages['thankyou.title']} />
              </div>
              <div className="page_sub_heading">
                <FormattedMessage {...messages['thankyou.subtitle']} />
              </div>
              <div className="page_sub_heading_2 thanks__pad2">
                <FormattedMessage {...messages['thankyou.details-title']} />
              </div>
              <ThanksDetails
                disruptions={disruptions}
                preventions={preventions}
                speedGain={speedGain}
                avgTime={avgTime}
                itOpsEmployees={itOpsEmployees}
                developers={developers}
                developerEffiencyGains={developerEffiencyGains}
                itOpsEffiencyGains={itOpsEffiencyGains}
                openSourceGains={openSourceGains}
                totalEffiencyGains={totalEffiencyGains}
                openSourceTechnoList={openSourceTechnoList}
                isPdf={isPdf}
                pdfObject={pdfObject}
                pdfExport={pdfExport}
              ></ThanksDetails>
              <ButtonSet
                className="instana-roi__stack-button thanks__pad3"
                stacked
              >
                <Button
                  onClick={() => {
                    segmentTracking('CTA Clicked', {
                      pageTitle: 'Instana ROI Estimator Page',
                      object: 'Thank you page',
                      resultValue: 'CTA clicked',
                      CTA: 'Return to Estimator',
                      location: 'Thankyou',
                      action: '',
                      field: '',
                    });
                    window.location.reload();
                  }}
                >
                  <FormattedMessage {...messages['return-to-estimator']} />
                </Button>
              </ButtonSet>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
};

export default Thanks;
